import '../plugins/MasonryPlugin.js';
import '../plugins/ImageLoadedPlugin.js';

// masonry init
export default function initMasonry() {
	jQuery('.masonry').masonry({
		itemSelector: '.grid-item',
		columnWidth: 1,
		resize: true,
		isOriginLeft: true
	});

	jQuery('.masonry').each((i, grid) => {
		jQuery(grid).imagesLoaded(() => {
			if (jQuery(grid).data('masonry')) {
				jQuery(grid).masonry('layout');
			}
		});
	});
}